'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('selfAccessRequestControllers')

    .controller('AdHocConfirmationController',
    ['$scope', '$state', '$stateParams', '$translate', 'topBar', 'selfAccessRequestService', 'selfAccessRequest', 'decisionListWithImpact', 'processStep', 'specialNeedsFollowup',
        function ($scope, $state, $stateParams, $translate, topBar, selfAccessRequestService,  selfAccessRequest, decisionListWithImpact, processStep, specialNeedsFollowup) {

         // Load translation asynchronously to avoid race condition
         $translate('iam.selfAccessRequest.adHoc.pageTitle').then(function(translation) {
             topBar.setTitleAndIcon(translation + ' &nbsp;<i class="fa fa-chevron-right fa-align"></i>&nbsp; ' +
                              '<i class="' + processStep.CssIcon + '"></i> ' + processStep.StepTitleEN, 'fa-shopping-cart');
         });


        $scope.newIamUrl = environment.iamUrl;

        $scope.processStep = processStep;
        $scope.selfAccessRequest = selfAccessRequest;
        $scope.currentUserId = selfAccessRequest.EmployeeID;
        $scope.systemTypes = decisionListWithImpact;
        $scope.specialRequestComment = specialNeedsFollowup.Comment;

        $scope.isRequestEmpty = _.size(decisionListWithImpact) === 0 &&
                                _.size($scope.specialRequestComment) === 0;
        $scope.canSubmitRequest = !processStep.IsReadOnly && !$scope.isRequestEmpty;
        $scope.specialNeedsStep = _.find(selfAccessRequest.ProcessStepStatusList, {Step: 'SpecialNeeds'});

        // Expand the Systems
        $scope.expand = function (systemType) {
            systemType.IsExpanded = !systemType.IsExpanded;
        }

        // Submit Request
        $scope.submitRequest = function () {
            selfAccessRequestService
                .confirmProcessStepForSelfAccessRequest($stateParams.userAccessRequestId, 'Submit')
                .then(function (data) {
                    window.location = $scope.newIamUrl;
                });
        }

        // Reset Ownership
        $scope.deleteOwnership = function () {
            selfAccessRequestService
                .deleteAdHocSelfAccessRequest($stateParams.userAccessRequestId)
                .then(function (response) {
                    window.location = $scope.newIamUrl;
                });
        }
}]);
